<button type="button" class="hamburger" aria-label="Navigation menu" (click)="toggleMobileNav()" [attr.aria-expanded] ="isMobileNavOpen">
    <span [ngClass]="{ 'close-hamburger': isMobileNavOpen }" class="hamburger-stripes"></span>
</button>

<div class="mobile-menu-list" [ngClass]="{ 'pages-visible': isMobileNavOpen }">
    <div class="mobile-menu-items">
        <xm-nav-profile class="easing" (toggleMobileNav)="toggleMobileNav()"></xm-nav-profile>
        <div class="mobile-menu-item easing separator" *ngIf="(isCBMAccountSelectorEnabled || isOrionAccountSelectorEnabled) && linkedAccounts?.length && isBusinessUser && isLoggedIn">
            <cbm-nav-menu-item [isMobile]="true" [linkedAccounts]="linkedAccounts" (toggleMobileNav)="toggleMobileNav()"></cbm-nav-menu-item>
        </div>
        <div *ngFor="let mobileMenuItem of mobileMenuItems" class="mobile-menu-item easing">
            <xm-nav-menu-item [pageData]="mobileMenuItem" (toggleMobileNav)="toggleMobileNav()"></xm-nav-menu-item>
        </div>
    </div>
    <div class="login-container">
        <div *ngIf="isLoggedIn && !isBusinessUser" class="cta-link-container">
            <xm-decorated-text class="xm-btn-link-light cta-link" [inputString]="pageData.makePayment.linkDecoration"
                (click)="toggleMobileNav()"></xm-decorated-text>
            <xm-decorated-text *ngIf="coreAccountMenuItem" class="xm-btn-link-light cta-link"
                [inputString]="coreAccountMenuItem.linkDecoration" (click)="toggleMobileNav()"></xm-decorated-text>
        </div>
        <div class="login-logout-link">
            <a class="xm-btn-link-light" *ngIf="!isLoggedIn" [uiSref]="pageData.login.uiSref"
                (click)="toggleMobileNav()">{{ pageData.login.name }}</a>
            <a class="xm-btn-link-light" *ngIf="isLoggedIn" [uiSref]="pageData.logout.uiSref"
                (click)="toggleMobileNav()">{{ pageData.logout.name }}</a>
        </div>
        <div *ngIf="!isLoggedIn && !isBusinessUser" class="cta-link-container">
            <xm-decorated-text class="xm-btn-link-light cta-link" [inputString]="pageData.makePayment.linkDecoration"
                (click)="toggleMobileNav()"></xm-decorated-text>
            <xm-decorated-text *ngIf="coreAccountMenuItem" class="xm-btn-link-light cta-link" [inputString]="coreAccountMenuItem.linkDecoration"
                (click)="toggleMobileNav()"></xm-decorated-text>
        </div>
    </div>
</div>
